/**
 * Application Constants
 * Shared constants used across the application
 */

/**
 * Supported broker types
 */
export const SUPPORTED_BROKERS = ['zerodha', 'angelone', 'upstox', 'dhan'] as const;

/**
 * Broker display names
 */
export const BROKER_DISPLAY_NAMES: Record<string, string> = {
  zerodha: 'Zerodha',
  angelone: 'Angel One',
  upstox: 'Upstox',
  dhan: 'Dhan',
};

/**
 * Order types
 */
export const ORDER_TYPES = ['MARKET', 'LIMIT', 'SL', 'SL-M'] as const;

/**
 * Transaction types
 */
export const TRANSACTION_TYPES = ['BUY', 'SELL'] as const;

/**
 * Order statuses
 */
export const ORDER_STATUSES = ['PENDING', 'COMPLETE', 'REJECTED', 'CANCELLED'] as const;

/**
 * Portfolio sync scopes
 */
export const SYNC_SCOPES = ['holdings_only', 'transactions_only', 'both'] as const;

/**
 * API timeout (milliseconds)
 */
export const API_TIMEOUT = 30000;

/**
 * WebSocket reconnection delay (milliseconds)
 */
export const WS_RECONNECT_DELAY = 1000;

/**
 * Maximum WebSocket reconnection attempts
 */
export const WS_MAX_RECONNECT_ATTEMPTS = 5;

/**
 * Portfolio refresh interval (milliseconds)
 */
export const PORTFOLIO_REFRESH_INTERVAL = 60000; // 1 minute

/**
 * Cache TTL (milliseconds)
 */
export const CACHE_TTL = {
  PORTFOLIO: 60 * 1000, // 1 minute
  HOLDINGS: 60 * 1000, // 1 minute
  ORDERS: 30 * 1000, // 30 seconds
  MARKET_DATA: 5 * 1000, // 5 seconds
};

